import { FloraButton } from '@grupoboticario/flora-react';
import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { BRANDS } from 'config/environments/shared';
import { FeatureFlag } from 'domains/feature-flag.d';
import { isMobile as isMobileHelper } from 'helpers';
import { useFeatureFlag } from 'hooks';
import { useGlobalContext } from 'store';

import Styles from './VdfAdvice.styles';

export const VdfAdvice = () => {
  const isMobile = isMobileHelper();
  const { brand } = useGlobalContext();
  const isEud = brand.short == BRANDS.EUD;
  const { value: isVDFPaymentEnable, loading: isLoadingFeatureFlag } = useFeatureFlag(
    FeatureFlag.ENABLE_VDF_PAYMENT,
    false
  );

  if (!isVDFPaymentEnable && !isLoadingFeatureFlag) {
    return null;
  }

  return (
    <Styles.Banner align='center' justify='space-between' gap='$4'>
      <ResponsiveFloraTypography
        fontSize='bodySmallShort'
        color='$backgroundAltSecondary'
        css={{ alignItems: 'left' }}
      >
        {isEud
          ? 'Agora, seus pagamentos pendentes devem ser acessados no portal multimarcas!'
          : 'Trouxemos seus pagamentos pendentes de Eudora! Continue comprando através deste portal.'}
      </ResponsiveFloraTypography>
      {isEud && (
        <FloraButton
          size='small'
          target='_blank'
          as={Link}
          to={`${config.app.paymentVDFUrl}&utm_source=portal_eud&utm_medium=aviso_multimarcas&utm_content=acessar_portal_multimarcas`}
          has='iconRight'
          icon={isMobile ? undefined : <ArrowRightIcon size={16} />}
        >
          {isMobile ? 'Acessar' : 'Acessar portal multimarcas'}
        </FloraButton>
      )}
    </Styles.Banner>
  );
};
